<script lang="ts">
  import Meta from "$lib/components/meta/MetaContribution.svelte";
  import Dialog from "$components/modals/Dialog.svelte";
  import { dev } from "$app/environment";

  export let data;
  if (dev) console.log(data);
</script>

{#if data.contributions || data.bonus_contributions}
  <Dialog
    gallery={data.is_bonus ? data.bonus_contributions : data.contributions}
    title={data.member?.profile?.display_name ?? "Community Member"}
    subtitle="Showcase Gallery"
    discussions={data.discussions}
    enable_discussions
    is_member_gallery
  ></Dialog>
{/if}

{#key data.id}
  <!--
  <Meta
    episode={data.episode}
    contribution={data.additional_data}
    id={data.id}
    is_discussion={data.is_discussion}
  />
  -->
{/key}
